// src/lib/sponsoredTracking.js
import { db } from "../firebase";
import { doc, increment, serverTimestamp, updateDoc } from "firebase/firestore";

/**
 * Incrémente les clics d'un placement sponsorisé
 * + du deal source si présent.
 */
export async function trackSponsoredClick({
  placementId,
  sourceDealId,
}) {
  try {
    const updates = [];

    if (placementId) {
      updates.push(
        updateDoc(doc(db, "sponsoredPlacements", placementId), {
          clicks: increment(1),
          updatedAt: serverTimestamp(),
        })
      );
    }

    if (sourceDealId) {
      updates.push(
        updateDoc(doc(db, "vendorSponsoredDeals", sourceDealId), {
          clicks: increment(1),
          updatedAt: serverTimestamp(),
        })
      );
    }

    if (updates.length) {
      await Promise.all(updates);
    }
  } catch (err) {
    console.error("Erreur trackSponsoredClick:", err);
  }
}

/**
 * Incrémente les impressions d'un placement sponsorisé
 * + du deal source si présent.
 */
export async function trackSponsoredImpression({
  placementId,
  sourceDealId,
}) {
  try {
    const updates = [];

    if (placementId) {
      updates.push(
        updateDoc(doc(db, "sponsoredPlacements", placementId), {
          impressions: increment(1),
          updatedAt: serverTimestamp(),
        })
      );
    }

    if (sourceDealId) {
      updates.push(
        updateDoc(doc(db, "vendorSponsoredDeals", sourceDealId), {
          impressions: increment(1),
          updatedAt: serverTimestamp(),
        })
      );
    }

    if (updates.length) {
      await Promise.all(updates);
    }
  } catch (err) {
    console.error("Erreur trackSponsoredImpression:", err);
  }
}